import { createAction } from 'redux-actions';

export const TOGGLE_IS_TRANSLATING = 'Translations/TOGGLE_IS_TRANSLATING';
export const SET_TRANSLATING_ITEM = 'Translations/SET_TRANSLATING_ITEM';

export const toggleIsTranslating = createAction(TOGGLE_IS_TRANSLATING);
export const setTranslatingItem = createAction(SET_TRANSLATING_ITEM);
